module.exports = __webpack_public_path__ + "media/entities/61-f050893e.png";